import { ReactNode } from 'react'
import { t } from '@lingui/core/macro'

export type SummaryProps = {
  disableEdit?: boolean
  icon: ReactNode
  label: string
  onEdit?: () => void
  text?: string
}

export function Summary(props: SummaryProps) {
  const { disableEdit, icon, label, onEdit, text } = props

  return (
    <div className="flex items-center gap-3 py-0 pr-4 sm:pr-7">
      <span className="flex h-6 w-6 shrink-0 items-center justify-center">{icon}</span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-gray-700">{label}</div>
        {text && <div className="truncate text-sm text-gray-500">{text}</div>}
      </div>
      {!disableEdit && (
        <button
          aria-label={t`Modify`}
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gray-300 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary/40"
          onClick={onEdit}
          title={t`Modify`}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L8.582 18.07a4.5 4.5 0 01-1.897 1.13L3 20.25l1.05-3.685a4.5 4.5 0 011.13-1.897L16.862 4.487z" />
          </svg>
        </button>
      )}
    </div>
  )
}
